/**
 * Method to pass data to Optimize so the event/data shows in the splunk warehouse
 *
 * @async
 * @param {String} eventName - Name of the event to emit to splunk
 * @param {Object} [payload] - Data to emit to splunk (Optional)
 */
function trackEvent(eventName, payload = {}) {
  window.requestIdleCallback(() => {
    if (typeof payload !== 'object') {
      payload = { data: payload };
    }

    Object.assign(payload, { pageId: location.pathname });
    if (OptimizeSuite) {
      const { browserId } = OptimizeSuite.config.user;
      if (browserId) {
        Object.assign(payload, { b: browserId });
      }
      OptimizeSuite.TrackingHub.add(eventName, payload);
    }
  });
}

module.exports = trackEvent;
